import { render } from "./ServicesView.vue?vue&type=template&id=c6eab176&scoped=true"
const script = {}

import "./ServicesView.vue?vue&type=style&index=0&id=c6eab176&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6eab176"]])

export default __exports__